import {
    useState,
    forwardRef,
    useImperativeHandle,
    useEffect,
    useContext,
} from "react"

import ExpandableComponentContext from "../../Contexts/ExpandableComponentContext"


const LINKEDIN_PROFILE_REGEX =
    /^https:\/\/www\.linkedin\.com\/in\/[a-zA-Z0-9_-]{3,100}\/?(\?[a-zA-Z0-9=&_%.-]+)?$/

const LinkedinProfileUrlInput = forwardRef(({ disabled, data, isMandatory }, ref) => {

    const ExpandableComponentData = useContext(ExpandableComponentContext)

    const isInteracted = ExpandableComponentData ? ExpandableComponentData?.isInteracted : false

    const [value, setValue] = useState(data || "")
    const [error, setError] = useState(false)

    useEffect(() => {
        if (!data) {
            return
        }
        setValue(data)
    }, [data])

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            let validity

            if (value) {
                validity = LINKEDIN_PROFILE_REGEX.test(value)
            } else {
                validity = !isMandatory
            }

            if (validity) {
                setError(false)
            } else {
                if (isInteracted) {
                    setError(true)
                }
            }

            return {
                isValid: validity,
                value,
            }
        },
        resetData: () => {
            setValue("")
        },
    }))

    return (
        <div className="my-2">
            <label className="block text-sm font-medium text-gray-700">
                {`Linkedin Profile Url${isMandatory ? "*" : ""}`}
            </label>

            <input
                type="url"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                disabled={disabled}
                placeholder={"https://www.linkedin.com/in/your-profile-id"}
                className={`mt-1 mb-2 pr-10 pl-3 py-2 block w-full rounded-md border shadow-sm px-1 focus:ring-blue-500 focus:border-blue-500
                    ${error ? "border-red-500" : "border-gray-300"}`}
            />

            {error && (
                <p className="mt-1 text-sm text-red-600">
                    Enter a valid LinkedIn profile URL (e.g. https://www.linkedin.com/in/your-profile-id)
                </p>
            )}
        </div>
    )
})

export default LinkedinProfileUrlInput
